<template>
  <div class="mt-6 border-box">
    <loader v-if="pageGroups === null" />
    <div v-else>
      <div class="flex flex-wrap -mx-2">
        <div class="w-full md:w-1/4 px-2">
          <div class="bg-white rounded p-3">
            <details v-for="pageGroup in pageGroups" :key="pageGroup.id" class="mb-6" :open="selectedPage && selectedPage.ezine_page_group_id === pageGroup.id">
              <summary class="cursor-pointer">
                <i class="fas fa-folder fa-lg"></i> {{ pageGroup.name }}
              </summary>
              <div v-if="pageGroup.pages.length === 0" class="italic mt-3 block text-grey-dark">
                This group is empty.
              </div>
              <ul v-else class="mt-3 list-reset">
                <li v-for="page in pageGroup.pages" :key="page.id" class="rounded p-2 border mb-1" :class="page === selectedPage ? 'font-bold bg-grey-light' : 'bg-grey-lightest hover:bg-grey-light cursor-pointer'" @click="selectedPage = page">
                  {{ page.name }}
                </li>
              </ul>
            </details>

            <button @click="showNewPageModal = true">
              <i class="fas fa-plus-circle"></i> Create New Page
            </button>
          </div>
        </div>

        <div class="w-full md:w-3/4 px-2">
          <div>
            <div v-if="!selectedPage">
              No page selected
            </div>
            <ezine-page-editor v-else :page-id="selectedPage.id" @name-changed="selectedPage.name = $event" @deleted="deleteSelectedPage" />
          </div>
        </div>
      </div>

      <modal v-if="showNewPageModal" @leave="showNewPageModal = false" show-close-btn width="240px">
        <h2 class="font-bold text-sm mb-1">New Page</h2>
        <p class="mb-6">To create a new page, select a group below and enter the page name.</p>

        <div class="mb-6">
          <label>Group:</label>
          <select
            v-model="createPageForm.ezine_page_group_id"
            class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('ezine_page_group_id') }">
            <option v-for="pageGroup in pageGroups" :key="pageGroup.id" :value="pageGroup.id">
              {{ pageGroup.name }}
            </option>
          </select>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('ezine_page_group_id')" v-text="errorBag.get('ezine_page_group_id')"></small>
        </div>

        <div class="mb-6">
          <label>Name:</label>
          <input v-model="createPageForm.name"
            class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('name') }" />
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('name')" v-text="errorBag.get('name')"></small>
        </div>

        <div class="flex justify-end mt-6">
          <button class="bg-transparent text-white py-2 px-6 text-sm bg-green-dark rounded shadow" :class="{'hover:bg-green': !creating}" @click="createPage" :disabled="creating">
            <loader v-if="creating" fill-color="white" />
            <span v-else><i class="fas fa-plus-circle"></i> Create Page</span>
          </button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'
import ErrorBag from '@/ErrorBag'
import { find } from 'lodash'
import EzinePageEditor from '../../components/Ezines/EzinePageEditor.vue'

export default {
  components: { EzinePageEditor },
  created () {
    this.search()
  },
  data () {
    return {
      pageGroups: null,
      selectedPage: null,
      showNewPageModal: false,
      creating: false,
      createPageForm: {
        ezine_page_group_id: null,
        name: null
      },
      errorBag: new ErrorBag()
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    search () {
      v2Api.get('ezine-page-groups', {
        params: {
          client_id: this.selectedOffice.client_id
        }
      }).then((response) => {
        this.pageGroups = response.data
        this.createPageForm.ezine_page_group_id = this.pageGroups[0].id
        const selectedGroup = find(this.pageGroups, (pageGroup) => pageGroup.pages.length)
        if (selectedGroup) {
          this.selectedPage = selectedGroup.pages[0]
        }
      })
    },
    createPage () {
      this.creating = true
      this.errorBag.clear()

      v2Api.post('ezine-pages', this.createPageForm).then((response) => {
        let group = find(this.pageGroups, (pageGroup) => pageGroup.id === response.data.ezine_page_group_id)
        if (!group) {
          return
        }

        group.pages.push(response.data)
        this.selectedPage = group.pages[group.pages.length - 1]
        this.creating = false
        this.showNewPageModal = false
      }, (errors) => {
        this.errorBag.store(errors.response.data)
        this.creating = false
      })
    },
    deleteSelectedPage () {
      this.selectedPage = null
      this.search()
    }
  },
  watch: {
    selectedOffice () {
      this.search()
    }
  }
}
</script>
